import { Modal as MUIModal, Box, Divider, Typography } from '@mui/material'
import React from 'react'
import IconButton from '../IconButton/IconButton'
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import MenuIcon from '@mui/icons-material/Menu';

export default function Modal({
	open,
	onClose,
	children,
	title,
	subtitle,
	onMenuClick,
	favorite,
	onFavoriteClick,
	hideCloseButton = false,
	disableEscapeKeyDown = false
}) {
	const hasHeaderIcons = onMenuClick || onFavoriteClick || !hideCloseButton;
	const shouldCenterTitle = hideCloseButton && !hasHeaderIcons;
	
	return (
		<MUIModal open={open} onClose={onClose} disableEscapeKeyDown={disableEscapeKeyDown}>
			<Box className="modal-box blue">
				<Box 
					className="modal-header"
					sx={{
						justifyContent: shouldCenterTitle ? 'center' : 'space-between',
						position: 'relative'
					}}
				>
					{(title || subtitle) && (
						<Box sx={{
							width: shouldCenterTitle ? '100%' : 'auto',
							textAlign: shouldCenterTitle ? 'center' : 'left'
						}}>
							{title && <Typography variant='h3'>{title}</Typography>}
							{subtitle && <Typography sx={{ marginTop: "10px" }} variant='body2'>{subtitle}</Typography>}
						</Box>
					)}
					{hasHeaderIcons && (
						<Box className="modal-header-icons" sx={{
							position: shouldCenterTitle ? 'absolute' : 'relative',
							right: shouldCenterTitle ? 0 : 'auto'
						}}>
							{onMenuClick &&
								<IconButton size="large" icon={MenuIcon} onClick={onMenuClick} />
							}
							{onFavoriteClick &&
								<IconButton size="large" icon={StarIcon} color={favorite ? "#FFC554" : "transparent"} fill={favorite ? "#FFC554" : "transparent"} onClick={onFavoriteClick} />
							}
							{(onMenuClick || onFavoriteClick) && <Divider orientation='vertical' />}
							{!hideCloseButton && <IconButton size={"large"} icon={CloseIcon} onClick={onClose} />}
						</Box>
					)}
				</Box>
				<Box className="modal-content">
					{children}
				</Box>
			</Box>
		</MUIModal>
	)
}